import React, { useState } from "react";
import { Row, Col, Button, Modal, Typography, Collapse, List } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { reverse } from "named-urls";
import { useHistory } from "react-router-dom";
import TextArea from "../TextArea";
import { useCart } from "../../contexts/cart";
import { useAuth } from "../../contexts/auth";
import * as roles from "../../constants/roles";
import InputBox from "../InputBox";
import routes from "../../../routes";
import "./style.css";
const { Paragraph } = Typography;
const { Panel } = Collapse;

const colors = [
  "rgba(10, 128, 128, 0.3)",
  "rgba(255,179,186, 1)",
  "rgba( 255,223,186, 1)",
  "rgba(186,255,201, 1)",
  "rgba(186,225,255, 1)",
  "rgba(213, 214, 234, 1)",
  "rgba(246, 246, 235, 1)",
];

/* const styles = {
  title: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 3,
    color: "rgb(52, 61, 72)",
  },
  card: {
    border: "2px solid rgba(10, 128, 128, 0.6)",
    borderRadius: 6,
    padding: "20px 30px",
    width: 240,
    height: 350,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // marginRight: 30,
  },
  pill: {
    borderRadius: 20,
    padding: "0 7px",
    fontSize: 14,
  },
  section: {
    marginTop: 10,
  },
}; */

const Pill = ({ text }) => {
  return (
    <Paragraph
      style={{
        background: colors[Math.floor(Math.random() * 7)],
        marginBottom: 0,
        width: "fit-content",
        maxWidth: 175,
      }}
      className="pill"
      ellipsis={{ tooltip: text }}
      title={text}
    >
      {text}
    </Paragraph>
  );
};

const TestCard = ({ data }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [addToCartMode, setAddToCartMode] = useState(false);
  const [packageNotes, setPackageNotes] = useState("");
  const [sampleCount, setSampleCount] = useState("");
  const [sampleCountError, setSampleCountError] = useState(null);

  const auth = useAuth();
  const currentUser = auth.loggedInUser;
  const company = currentUser.company;
  const priceVisible = company.priceVisible;

  const history = useHistory();
  const cart = useCart();

  const { name, tests, _id } = data;
  let cost = 0;

  tests.forEach((test) => {
    cost = cost + test.price;
  });

  const commodity = tests[0]?.test?.commodity?.name;
  const categories = tests.map((test) => test.test.testCategory.name);
  const parameters = tests.map((test) => test.test.parameter);
  const distinctCategories = [...new Set(categories)];

  const testCategories = {};
  tests.forEach((test) => {
    const testCategory = test.test.testCategory;
    if (!testCategories[testCategory._id]) {
      testCategories[testCategory._id] = {
        name: testCategory.name,
        tests: [],
      };
    }
    let testObj = { ...test?.test };
    testObj.price = test.price;
    testCategories[testCategory._id].tests.push(testObj);
  });

  const handleSuccess = () => {
    setModalVisible(false);
    history.push(reverse(routes.cart));
  };

  const handleOk = () => {
    if (!addToCartMode) {
      setAddToCartMode(true);
    } else {
      // Add to cart
      if (sampleCount < 1)
        setSampleCountError("Please select value for sample count");
      else {
        const cartPackage = {
          notes: packageNotes,
          package: {
            name,
            _id,
            tests: tests.map((test) => test._id),
          },
          sampleCount: sampleCount,
          fromRecommendedPackage: true,
        };

        cart.addToCart(cartPackage, handleSuccess);
      }
    }
  };

  const handleCancel = () => {
    setSampleCountError(null);
    setAddToCartMode(false);
    setModalVisible(false);
  };

  const handleSampleCount = (val) => {
    if (val > 100) {
      return null;
    } else if (val > 0) {
      setSampleCount(val);
    } else {
      setSampleCount(0);
    }
  };

  const renderTestCategories = (entries) => {
    const rows = [];
    Object.keys(entries).forEach((key, index) => {
      const entry = entries[key];
      const tests = entry.tests || {};
      // const selected = getSelectedTestsCount(entry._id);
      if (tests.length) {
        rows.push(
          <Panel
            header={
              <span
                style={{ fontWeight: "bold", color: "#0a8080" }}
                id="testCategory"
              >
                {entry.name} ({tests.length} tests)
              </span>
            }
            key={index}
            style={{
              marginBottom: 20,
              overflow: "hidden",
              backgroundColor: "#eff3f7",
              border: "0px",
              borderRadius: 4,
              color: "#0a8080",
            }}
          >
            <div>
              <List
                itemLayout="horizontal"
                dataSource={tests}
                renderItem={(test) => (
                  <List.Item>
                    <List.Item.Meta
                      title={<span className="test">{test.parameter}</span>}
                    />
                    {currentUser.role === roles.COMPANY_ADMIN.name ||
                    priceVisible ? (
                      <div className="test"> ₹ {test.price}</div>
                    ) : (
                      ""
                    )}
                  </List.Item>
                )}
              />
            </div>
          </Panel>
        );
      }
    });
    return rows;
  };

  return (
    <div style={{ paddingRight: 30 }}>
      <div className="card">
        <div className="titleCard">
          <Paragraph ellipsis={{ tooltip: name }} title={name} id="titlePara">
            {name}
          </Paragraph>
          <Paragraph id="titleParaDescription">
            {parameters.length} tests included
          </Paragraph>
        </div>
        <div className="section" id="commodityCard">
          <p className="title">COMMODTIY</p>
          <Pill text={commodity} />
        </div>
        <div className="section" id="categoriesCard">
          <p className="title">CATEGORIES</p>
          <Row gutter={[15, 5]}>
            {distinctCategories.map((cat) => (
              <Col>
                <Pill text={cat} />
              </Col>
            ))}
          </Row>
        </div>
        {(currentUser.role === roles.COMPANY_ADMIN.name || priceVisible) && (
          <div className="section" id="unitCostCard">
            <p className="title">UNIT COST</p>
            <span style={{ fontSize: 12 }}>₹ {cost}</span>
          </div>
        )}
        <div className="knowMore">
          <Button
            size="small"
            style={{ borderRadius: 20 }}
            type="primary"
            block
            onClick={() => setModalVisible(true)}
          >
            Know More
          </Button>
        </div>
        <Modal
          title={name}
          visible={modalVisible}
          onOk={handleOk}
          cancelText="Close"
          okText={addToCartMode ? "Add to Cart" : "Book Package"}
          onCancel={handleCancel}
        >
          {!addToCartMode ? (
            <div>
              <div className="section">
                <p className="title">COMMODTIY</p>
                <Pill text={commodity} />
              </div>
              <div className="section">
                <p className="title">CATEGORIES</p>
                <Row gutter={[15, 5]}>
                  {distinctCategories.map((cat) => (
                    <Col>
                      <Pill text={cat} />
                    </Col>
                  ))}
                </Row>
              </div>
              {(currentUser.role === roles.COMPANY_ADMIN.name ||
                priceVisible) && (
                <div style={{ height: 40 }} className="section">
                  <p className="title">UNIT COST</p>
                  <span style={{ fontSize: 12 }}>₹ {cost}</span>
                </div>
              )}
              <div className="section">
                <p className="title">TOTAL TESTS</p>
                <span style={{ fontSize: 12 }}>{parameters.length}</span>
              </div>
              <div className="section">
                <p className="title">PARAMETERS</p>
                <Collapse
                  bordered={false}
                  expandIconPosition="right"
                  expandIcon={({ isActive }) => (
                    <CaretRightOutlined
                      style={{ color: "#0a8080" }}
                      rotate={isActive ? 90 : 0}
                    />
                  )}
                  style={{ background: "#fff" }}
                >
                  {renderTestCategories(testCategories)}
                </Collapse>
              </div>
            </div>
          ) : (
            <div>
              <InputBox
                placeholder="Enter number of samples to be picked"
                value={sampleCount}
                min={0}
                max={100}
                onFocus={(e) => setSampleCountError(null)}
                onChange={(e) => handleSampleCount(e.target.value)}
                label="Sample Count"
                type="number"
              />
              {sampleCountError && (
                <p
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {sampleCountError}
                </p>
              )}
              <TextArea
                placeholder="Add any relevant instructions"
                value={packageNotes}
                onChange={(e) => setPackageNotes(e.target.value)}
                label="Notes/Instructions"
              />
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default TestCard;
